import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(theme => ({
  root: {
    backgroundColor: theme.colors.backgroundLight,
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
